import React, { useState } from "react";
import { FileUpload, DeleteIcon } from "../../assets/svg";

const FileUploadChoose = ({
  handleFileChange,
  className,
  uploadedFiles = [],
  onDelete,
  disabled,
  uploadIcon,
  uploadText,
  deleteIcon,
  accept,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const onFileChange = async (event) => {
    setIsUploading(true);
    try {
      await handleFileChange(event);
    } finally {
      setIsUploading(false);
    }
  };

  const handlePreview = (fileObj) => {
    setSelectedFile(fileObj);
  };

  return (
    <div
      className={`relative flex flex-col items-center justify-center border ${
        !disabled
          ? "border-gray-300 cursor-not-allowed"
          : "border-dashed cursor-pointer"
      } border-borderDot rounded-2xl overflow-hidden px-4 py-8 ${className}`}
    >
      {/* Loader Overlay */}
      {isUploading && (
        <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-20">
          <div className="w-12 h-12 border-4 border-themeBtn border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      {/* Uploaded Files */}
      {uploadedFiles.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-4">
          {uploadedFiles.map((fileObj, index) => {
            const isVideo =
              fileObj.type?.startsWith("video/") ||
              fileObj.url?.toLowerCase().endsWith(".mov") ||
              fileObj.url?.toLowerCase().endsWith(".mp4");

            return (
              <div
                key={index}
                className="relative w-24 h-24 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center cursor-pointer"
                onClick={() => handlePreview(fileObj)}
              >
                {isVideo ? (
                  <video
                    src={fileObj.url}
                    className="w-full h-full object-cover"
                    muted
                  />
                ) : (
                  <img
                    src={fileObj.url}
                    alt={fileObj.name || `file-${index}`}
                    className="w-full h-full object-cover"
                  />
                )}

                {isVideo && (
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center text-white text-lg">
                    ▶
                  </div>
                )}

                {!disabled && (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onDelete?.(index);
                    }}
                    className="absolute top-1 right-1 w-7 h-7 flex items-center justify-center
             bg-white text-red-500 rounded-full shadow-md hover:bg-red-500 hover:text-white
             transition-all duration-200 z-20"
                  >
                    {deleteIcon || <DeleteIcon className="w-4 h-4" />}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Upload Area (clickable) */}
      {!disabled && (
        <label className="mt-4 flex flex-col items-center cursor-pointer">
          {uploadIcon || <FileUpload width={60} height={60} className="mb-4" />}
          {uploadText || (
            <>
              <p className="text-base mb-2 font-Proxima">
                Drag and Drop or{" "}
                <span className="text-[#0288d1] font-Proxima">
                  choose your file
                </span>{" "}
                for upload
              </p>
              <p className="text-textSecondary text-base font-Proxima">
                jpeg, jpg, png, mp4, mov (max. 25mb)
              </p>
            </>
          )}
          <input
            type="file"
            onChange={onFileChange}
            accept={accept || "image/*,video/*"}
            disabled={disabled}
            multiple
            className="hidden"
          />
        </label>
      )}

      {/* Full-Screen Preview */}
      {selectedFile && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
          onClick={() => setSelectedFile(null)}
        >
          <div className="relative max-w-4xl max-h-[90vh] w-auto h-auto">
            {selectedFile.type?.startsWith("video/") ||
            selectedFile.url?.toLowerCase().endsWith(".mp4") ||
            selectedFile.url?.toLowerCase().endsWith(".mov") ? (
              <video
                src={selectedFile.url}
                controls
                autoPlay
                className="max-h-[90vh] rounded-lg"
              />
            ) : (
              <img
                src={selectedFile.url}
                alt={selectedFile.name}
                className="max-h-[90vh] rounded-lg"
              />
            )}

            <button
              className="absolute -top-10 right-0 text-white text-3xl"
              onClick={() => setSelectedFile(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUploadChoose;
